import { defineSlotRecipe } from '@chakra-ui/react';

export const selectTableSlotRecipe = defineSlotRecipe({
	className: 'select-table',
	base:      {
		cell: {
			// borderTop: '1px solid {colors.gray.15}',
			px:        6,
			py:        4,
			textAlign: 'left',
			textStyle: 'p5',
		},
		column: {
			bg:           'white',
			borderBottom: '1px solid {colors.gray.15}',
			color:        'gray.100',
			minW:         '120px',
			position:     'sticky',
			px:           6,
			py:           4,
			textAlign:    'left',
			textStyle:    's5',
			top:          0,
			w:            '1%',
			whiteSpace:   'nowrap',
			zIndex:       2,
		},
		header: {
			bg:     'white',
			zIndex: 50,
		},
		root: {
			bg:          'white',
			tableLayout: 'auto',
			w:           'full',
		},
	},
	slots: [
		'root',
		'cell',
		'header',
		'column',
		'footer',
		'row',
		'body',
		'scroll',
	],
});
